module.exports = __webpack_public_path__ + "img/FR12406.924b5136.svg";